import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/hari-ini")({
  beforeLoad: () => {
    throw redirect({ to: "/en/today" } as any as any);
  },
  component: () => null,
});
